import { render, staticRenderFns } from "./technicalServiceFeeList.vue?vue&type=template&id=2fc63710&scoped=true"
import script from "./technicalServiceFeeList.vue?vue&type=script&lang=ts"
export * from "./technicalServiceFeeList.vue?vue&type=script&lang=ts"
import style0 from "./technicalServiceFeeList.vue?vue&type=style&index=0&id=2fc63710&prod&lang=stylus&scoped=true"
import style1 from "./technicalServiceFeeList.vue?vue&type=style&index=1&id=2fc63710&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc63710",
  null
  
)

export default component.exports